/** @format */

import { fetch } from '../../utils/fetch';
import { functionId, functionIdCoupon, appId } from '../../utils/functionIdConfig';
interface IfetchResponse {
  code: string;
  msg: string;
  data: any;
}
const Service = {
  loadData: (params_json: object = {}): Promise<any> => {
    const defaultParams = {
      // 根据sku list查询对比详情
      action: '4',
    };
    const params = Object.assign({}, defaultParams, params_json);
    return fetch(functionId, JSON.stringify(params));
  },
  switchCate: (params_json: object = {}): Promise<any> => {
    const defaultParams = {
      // 根据pin和三级类目id查询对比详情
      action: '3',
    };
    const params = Object.assign({}, defaultParams, params_json);
    return fetch(functionId, JSON.stringify(params));
  },
  delSku: (params_json: object = {}): Promise<any> => {
    const defaultParams = {
      // 根据pin和三级类目id查询对比详情
      action: '2',
    };
    const params = Object.assign({}, defaultParams, params_json);
    return fetch(functionId, JSON.stringify(params));
  },
  addGoods: (params_json: { compareSku: string; delSkus: string; compareCid: string }): Promise<any> => {
    const defaultParams = {
      action: '1',
      //要添加的sku
      compareSku: params_json.compareSku,
      delSkus: params_json.delSkus,
      compareCid: params_json.compareCid,
    };
    return fetch(functionId, JSON.stringify(defaultParams));
  },
  getCoupon: (params_json: { couponKey: string; roleId: number; sku: string }): Promise<any> => {
    const defaultParams = {
      //单个券0多个1
      isBatchReceive: 0,
      //商详 2
      source: '2',
      //免费领券
      receiveType: 1,
      //跳转地址
      childActivityUrl: `http://openapp.jdmobile://virtual?params={"category":"jump","des":"productDetail","skuId":${params_json.sku}}`,
      couponKey: params_json.couponKey,
      ruleId: params_json.roleId,
    };
    return fetch(functionIdCoupon, JSON.stringify(defaultParams));
  },
};
export default Service;
